import { TableCell } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

const TableCellWithConfig = (props) => {
  const { config, children, className, boxShadowColor, width } = props;

  if (!config.hidden) {
    let styleObject = {};
    if (width) {
      styleObject.width = width;
    }
    if (boxShadowColor) {
      styleObject.boxShadow = `inset 10px 0px 0px 0px ${boxShadowColor}`;
    }
    if (children) {
      return (
        <TableCell className={className} style={styleObject}>
          {children}
        </TableCell>
      );
    } else {
      return <TableCell className={className} style={styleObject}></TableCell>;
    }
  }

  return null;
};

TableCellWithConfig.propTypes = {
  config: PropTypes.shape({ hidden: PropTypes.bool.isRequired }).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  boxShadowColor: PropTypes.string,
  width: PropTypes.string,
};

export default TableCellWithConfig;
